<template>
  <div>
    <mainHeader title="Wallet Address"></mainHeader>
    <div style="padding: 0 12px;">


    <h1>Wallet Address</h1>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ active: type === 'USDT' }"
          @click="changeType('USDT')"
          >USDT</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ active: type === 'Bank card' }"
          @click="changeType('Bank card')"
          >Bank card</a
        >
      </li>
    </ul>
    <div class="table-btns">
      <button class="btn btn-primary" @click="addWalletAddr">Add</button>
    </div>
    <table class="table" v-if="type === 'USDT'">
      <thead>
        <tr>
          <th scope="col">Currency</th>
          <th scope="col">Address</th>
          <th scope="col">Date</th>
          <th scope="col">Options</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id">
          <td>{{ item.type + " - " + item.link }}</td>
          <td>{{ item.addr }}</td>
          <td>{{ formatTime(item.addtime * 1000) }}</td>
          <td>
            <button class="btn btn-danger" @click="deleteWalletAddr(item.id)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table" v-if="type === 'Bank card'">
      <thead>
        <tr>
          <th scope="col">Bank name</th>
          <th scope="col">Bank card type</th>
          <th scope="col">Bank code</th>
          <th scope="col">Bank account number</th>
          <th scope="col">Date</th>
          <th scope="col">Options</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data2" :key="item.id">
          <td>{{ item.bank_name }}</td>
          <td>{{ item.bank_account_type }}</td>
          <td>{{ item.bank_routing_number }}</td>
          <td>{{ item.bank_account_number }}</td>
          <td>{{ formatTime(item.addtime * 1000) }}</td>
          <td>
            <button class="btn btn-danger" @click="deleteWalletAddr(item.id)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getWalletAddr, delWalletAddr } from "@/apis/wallet";
import mainHeader from '@/components/mainHeader.vue';
export default {
  components: {
    mainHeader
  },
  data() {
    return {
      type: "USDT",
      data: [],
      data2: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    changeType(type) {
      this.type = type;
      this.getData();
    },
    getData() {
      if (this.type === "USDT") {
        this.getData1();
      } else {
        this.getData2();
      }
    },
    getData1() {
      getWalletAddr({
        type: "USDT",
      }).then((res) => {
        console.log(res);
        this.data = res.data;
      });
    },
    getData2() {
      getWalletAddr({
        type: "BANK",
      }).then((res) => {
        console.log(res);
        this.data2 = res.data;
      });
    },
    deleteWalletAddr(id) {
      // 确认下
      if (confirm("Are you sure you want to delete this wallet address?")) {
        delWalletAddr({ id }).then((res) => {
          console.log(res);
          this.getData();
        });
      }
    },
    addWalletAddr() {
      if (this.type === "USDT") {
        this.$router.push("/user/add-wallet-address");
      } else {
        this.$router.push("/user/add-bank-card");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-btns {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: right;
}
.nav-tabs {
  padding-left: 10px;
}
.nav-tabs .nav-link {
  cursor: pointer;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-link:hover {
  border-color: #dee2e6 #dee2e6 #fff;
}
.dark {
  .nav-tabs {
    border-bottom: 1px solid #495057;
  }
  .nav-tabs .nav-link.active {
    color: #fff;
  }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-link:hover {
    border-color: #495057 #495057 #131722;
  }
}
</style>
